import { useParams, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { ArrowLeft, RefreshCw } from 'lucide-react'
import LetterEditor from '@/components/LetterEditor'
import api from '@/services/api'

export default function LetterEditorPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [letter, setLetter] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchLetter = async () => {
    try {
      setLoading(true)
      const res = await api.get(`/api/v1/letters/${id}`)
      setLetter(res.data)
      setError(null)
    } catch {
      setError('Failed to load letter')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) fetchLetter()
  }, [id])

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <RefreshCw className="w-8 h-8 text-slate-500 animate-spin" />
      </div>
    )
  }

  if (error || !letter) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
        <p className="text-slate-300 mb-4">{error || 'Letter not found'}</p>
        <button onClick={() => navigate('/letters')} className="btn-secondary flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" />
          Back to Letters
        </button>
      </div>
    )
  }

  return (
    <LetterEditor
      letter={letter}
      onUpdate={fetchLetter}
      onClose={() => navigate('/letters')}
    />
  )
}
